import * as React from "react";
const SvgStatus = (props) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M3.75 6.75H16.25L20.25 12L16.25 17.25H3.75V6.75Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinejoin: "round" }));
export default SvgStatus;
